// @ts-nocheck
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Package, Settings, Pencil, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useStore } from "@tanstack/react-form";
import { useQuery } from "@tanstack/react-query";
import { trpcClient } from "@/lib/trpc";
import { useState } from "react";
import { TanstackFieldWrapper, TanstackFormControl } from "@/components/ui/tanstack-form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ComboboxFK } from "@/components/shared/ComboboxFK";
import { SharedCombobox } from "@/components/shared/SharedCombobox";
import { ConfigCombobox } from "@/components/shared/ConfigCombobox";
import { NumericInput } from "@/components/ui/numeric-input";
import { POSVGMarquette } from "./POSVGMarquette";
import { getUploadUrl } from "@/lib/utils";

function TextField({
  field,
  label,
  required,
  placeholder,
  type = "text",
}: {
  field: any;
  label: string;
  required?: boolean;
  placeholder?: string;
  type?: string;
}) {
  return (
    <TanstackFieldWrapper field={field} label={label} required={required}>
      <TanstackFormControl>
        <Input
          id={field.name}
          type={type}
          value={field.state.value ?? ""}
          placeholder={placeholder}
          className="h-9"
          onChange={(e) => field.handleChange(type === "number" ? (e.target.value ? Number(e.target.value) : "") : e.target.value)}
          onBlur={field.handleBlur}
        />
      </TanstackFormControl>
    </TanstackFieldWrapper>
  );
}

export function POHeader({ 
  form, 
  orderData, 
  selectedCustomerId, 
  selectedSalesOrderId,
  onSyncTechSpecs,
  defaultValues,
  isEdit
}: { 
  form: any; 
  orderData: any; 
  selectedCustomerId: string | null; 
  selectedSalesOrderId: string | null;
  onSyncTechSpecs?: () => void;
  defaultValues?: any;
  isEdit?: boolean;
}) {
  const productId = useStore(form.store, (s: any) => s.values.productId);
  const printingPaperSize = useStore(form.store, (s: any) => s.values.printingPaperSize);
  const prepressPcsPerSheet = useStore(form.store, (s: any) => s.values.prepressPcsPerSheet);
  const layoutCode = useStore(form.store, (s: any) => s.values.layoutCode);
  const [mediaTab, setMediaTab] = useState<"marquette" | "image">("marquette");

  const { data: productInfo } = useQuery({
    queryKey: ["product-getById", productId],
    queryFn: () => trpcClient.products.getById.query({ id: productId }),
    enabled: !!productId,
  });
  const [inventory, setInventory] = useState(0);
  const [allowancePct, setAllowancePct] = useState(0);

  // Tính toán khổ in và số con thời gian thực cho Live Marquette Blueprint
  const rawPaperSize = printingPaperSize || productInfo?.printSize || "42.5x67";
  const sizeParts = String(rawPaperSize)
    .toLowerCase()
    .split(/[x*]/)
    .map((s: string) => parseFloat(s.trim()))
    .filter((n: number) => !isNaN(n));
  const sheetWidth = sizeParts[0] || 42.5;
  const sheetHeight = sizeParts[1] || 67;
  const upsCount = prepressPcsPerSheet || (productInfo?.outs ? parseInt(String(productInfo.outs)) : 24);

  return (
    <>
      
              {/* ── Card 1: Thông tin đơn sản xuất ── */}
              <Card className="border-none shadow-sm ring-1 ring-slate-200">
                <CardHeader className="bg-slate-50/50 py-3 border-b">
                  <CardTitle className="text-sm font-bold flex items-center gap-2">
                    <Package className="h-4 w-4 text-slate-500" /> Thông tin đơn
                    sản xuất
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4">
                  <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                    {/* 3/4 Cột text */}
                    <div className="lg:col-span-3 space-y-4">
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-x-4 gap-y-4">
                        {/* Dòng 1 */}
                        <div className="col-span-1 md:col-span-2">
                          <form.Field name="customerId">
                            {(field: any) => (
                              <TanstackFieldWrapper
                                field={field}
                                label="Khách hàng"
                                required
                              >
                                <TanstackFormControl>
                                  <SharedCombobox
                                    id="customerId"
                                    dataField="customerId"
                                    required={true}
                                    type="customer"
                                    value={(field.state.value as string) || ""}
                                    valueLabel={defaultValues?.customerName || defaultValues?.customer?.name || (defaultValues as any)?.customer?.shortName}
                                    onChange={(id, opt) => {
                                      field.handleChange(id);
                                      if (!isEdit && id && id !== selectedCustomerId) {
                                        form.setFieldValue("salesOrderId", "");
                                        form.setFieldValue("productId", "");
                                      }
                                    }}
                                    placeholder="Chọn KH..."
                                  />
                                </TanstackFormControl>
                              </TanstackFieldWrapper>
                            )}
                          </form.Field>
                        </div>
                        <div className="col-span-1 md:col-span-2">
                          <form.Field name="salesOrderId">
                            {(field: any) => (
                              <TanstackFieldWrapper
                                field={field}
                                label="Đơn hàng (Sales Order)"
                              >
                                <TanstackFormControl>
                                  <SharedCombobox
                                    type="order"
                                    params={{
                                      customerId:
                                        selectedCustomerId || undefined,
                                      forPlanning: true,
                                    }}
                                    value={(field.state.value as string) || ""}
                                    valueLabel={defaultValues?.salesOrderNumber || defaultValues?.salesOrder?.orderId || defaultValues?.salesOrderId}
                                    onChange={(id, opt) => {
                                      field.handleChange(id);
                                      if (opt?.original?.customerId && !form.getFieldValue("customerId")) {
                                        form.setFieldValue("customerId", opt.original.customerId);
                                      }
                                    }}
                                    placeholder="Chọn hoặc tìm mã đơn hàng..."
                                  />
                                </TanstackFormControl>
                              </TanstackFieldWrapper>
                            )}
                          </form.Field>
                        </div>
                        {selectedSalesOrderId && (
                          <div className="col-span-1 md:col-span-4 bg-indigo-50/50 p-3 rounded-lg border border-indigo-100 mb-2">
                            <form.Field name="orderDetailId">
                              {(field: any) => {
                                const rawOptions = (orderData?.orderDetails || []).map((detail: any) => ({
                                  id: detail.id,
                                  label: detail.productName || "—",
                                  subLabel: detail.productCode || "",
                                  meta: `SL: ${detail.quantity}`,
                                  original: detail,
                                }));
                                const currentVal = field.state.value;
                                const hasCurrent = rawOptions.some((o: any) => o.id === currentVal);
                                const options = (!hasCurrent && currentVal)
                                  ? [
                                      {
                                        id: currentVal,
                                        label: defaultValues?.productName || "Sản phẩm hiện tại",
                                        subLabel: defaultValues?.poReference || "",
                                        meta: `SL: ${defaultValues?.quantity || 0}`,
                                      },
                                      ...rawOptions,
                                    ]
                                  : rawOptions;

                                return (
                                  <TanstackFieldWrapper
                                    field={field}
                                    label="Chọn Sản phẩm từ Đơn hàng để tự động điền"
                                  >
                                    <TanstackFormControl>
                                      <ComboboxFK
                                        value={currentVal || ""}
                                        valueLabel={defaultValues?.productName}
                                        onChange={(id) => {
                                          field.handleChange(id);
                                          const selectedDetail = (orderData?.orderDetails || []).find((d: any) => d.id === id);
                                          if (selectedDetail) {
                                            if (selectedDetail.productId) form.setFieldValue("productId", selectedDetail.productId);
                                            if (selectedDetail.productName) form.setFieldValue("productName", selectedDetail.productName);
                                            if (selectedDetail.quantity) form.setFieldValue("quantity", selectedDetail.quantity);
                                            if (selectedDetail.poReference) form.setFieldValue("poReference", selectedDetail.poReference);
                                          }
                                        }}
                                        options={options}
                                        placeholder="-- Chọn một sản phẩm trong đơn hàng --"
                                        className="h-9 bg-white border-indigo-200"
                                      />
                                    </TanstackFormControl>
                                  </TanstackFieldWrapper>
                                );
                              }}
                            </form.Field>
                          </div>
                        )}

                        {/* Dòng 2 */}
                        <div className="col-span-1 md:col-span-2 min-w-0">
                          <form.Field name="productId">
                            {(field: any) => (
                              <TanstackFieldWrapper
                                field={field}
                                label="Chọn Sản phẩm từ Master"
                                required
                              >
                                <TanstackFormControl>
                                  <div className="flex items-center gap-1.5 w-full min-w-0">
                                    <div className="flex-1 min-w-0 overflow-hidden">
                                      <SharedCombobox
                                        id="productId"
                                        dataField="productId"
                                        required={true}
                                        type="product"
                                        params={{
                                          customerId:
                                            selectedCustomerId || undefined,
                                        }}
                                        value={
                                          (field.state.value as string) || ""
                                        }
                                        valueLabel={defaultValues?.productName || defaultValues?.product?.productName || defaultValues?.product?.name}
                                        onChange={(id, opt) => {
                                          field.handleChange(id);
                                          if (opt) {
                                            const original = opt.original || {};
                                            form.setFieldValue(
                                              "productName",
                                              original.productName ||
                                                opt.label ||
                                                "",
                                            );
                                          }
                                        }}
                                        placeholder={
                                          selectedCustomerId
                                            ? "Tìm theo tên/mã SP..."
                                            : "Vui lòng chọn khách hàng trước"
                                        }
                                        disabled={!selectedCustomerId}
                                        canAdd={false}
                                      />
                                    </div>
                                    {field.state.value && (
                                      <Button
                                        type="button"
                                        variant="outline"
                                        size="icon"
                                        className="h-9 w-9 shrink-0 bg-white"
                                        title="Sửa Sản phẩm"
                                        onClick={() => {
                                          window.open(
                                            `/products/${field.state.value}/edit`,
                                            "_blank",
                                          );
                                        }}
                                      >
                                        <Pencil className="h-4 w-4 text-slate-500" />
                                      </Button>
                                    )}
                                    {field.state.value && onSyncTechSpecs && (
                                      <Button
                                        type="button"
                                        variant="secondary"
                                        size="sm"
                                        className="h-9 shrink-0 border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100"
                                        title="Đồng bộ Tiêu chuẩn Kỹ thuật (Vật tư, Công đoạn, Khuôn Kẽm)"
                                        onClick={onSyncTechSpecs}
                                      >
                                        <Sparkles className="h-4 w-4 mr-1" />
                                        <span>Đồng bộ TCKT</span>
                                      </Button>
                                    )}
                                  </div>
                                </TanstackFormControl>
                              </TanstackFieldWrapper>
                            )}
                          </form.Field>
                        </div>
                        <div className="col-span-1 md:col-span-2 min-w-0">
                          <form.Field name="productName">
                            {(field: any) => (
                              <TextField
                                field={field}
                                label="Tên hiển thị sản phẩm"
                                required
                                placeholder="Tên sản phẩm"
                              />
                            )}
                          </form.Field>
                        </div>

                        {/* Dòng 3 */}
                        <div className="col-span-1">
                          <form.Field name="poReference">
                            {(field: any) => (
                              <TextField
                                field={field}
                                label="Số PO"
                                required
                                placeholder="PO-RAC-001"
                              />
                            )}
                          </form.Field>
                        </div>
                        <div className="col-span-1 md:col-span-2">
                          <form.Field name="techSpecId">
                            {(field: any) => (
                              <TanstackFieldWrapper
                                field={field}
                                label="Tiêu chuẩn kỹ thuật"
                              >
                                <TanstackFormControl>
                                  <SharedCombobox
                                    type="technicalSpec"
                                    value={(field.state.value as string) || ""}
                                    valueLabel={defaultValues?.technicalSpec?.specId || defaultValues?.techSpecCode}
                                    onChange={(id: string) =>
                                      field.handleChange(id)
                                    }
                                    placeholder="Chọn TCKT..."
                                    className="h-9"
                                  />
                                </TanstackFormControl>
                              </TanstackFieldWrapper>
                            )}
                          </form.Field>
                        </div>
                        <div className="col-span-1 md:col-span-1">
                          <form.Field name="layoutCode">
                            {(field: any) => (
                              <TextField
                                field={field}
                                label="Mã Layout"
                                placeholder="Nhập mã layout..."
                              />
                            )}
                          </form.Field>
                        </div>
                        <div className="flex flex-col gap-0.5 justify-center mt-6">
                          <span className="text-[10px] uppercase font-semibold text-slate-500">
                            Mã sản phẩm
                          </span>
                          <span className="text-[13px] font-mono font-bold text-indigo-700">
                            {productInfo?.productCode || "—"}
                          </span>
                        </div>

                        {/* Các thông tin chi tiết Read-only render liền mạch phía dưới */}
                        {productInfo && (
                          <>
                            <div className="col-span-1 p-3 bg-slate-50 rounded-lg border border-slate-100 flex flex-col gap-1">
                              <span className="text-[10px] uppercase font-semibold text-slate-500">
                                Chất liệu
                              </span>
                              <span className="text-[13px] font-medium text-slate-900">
                                {productInfo.material?.name || productInfo.material?.materialId || "—"}
                              </span>
                            </div>
                            <div className="col-span-2 p-3 bg-slate-50 rounded-lg border border-slate-100 flex flex-col gap-1">
                              <span className="text-[10px] uppercase font-semibold text-slate-500">
                                Quy trình sản xuất
                              </span>
                              <span className="text-[13px] font-medium text-slate-900 leading-relaxed">
                                {productInfo.process || "—"}
                              </span>
                            </div>

                            {/* Khổ in, Khổ giấy (mua), Số bát - 3 cột 1 hàng */}
                            <div className="p-3 bg-slate-50 rounded-lg border border-slate-100 flex flex-col gap-1">
                              <span className="text-[10px] uppercase font-semibold text-slate-500">
                                Khổ giấy in
                              </span>
                              <span className="text-[13px] font-medium text-slate-900">
                                {productInfo.printSize || "—"}
                              </span>
                            </div>
                            <div className="p-3 bg-slate-50 rounded-lg border border-slate-100 flex flex-col gap-1">
                              <span className="text-[10px] uppercase font-semibold text-slate-500">
                                Khổ mua
                              </span>
                              <span className="text-[13px] font-medium text-slate-900">
                                {productInfo.paperSize || "—"}
                              </span>
                            </div>
                            <div className="p-3 bg-slate-50 rounded-lg border border-slate-100 flex flex-col gap-1">
                              <span className="text-[10px] uppercase font-semibold text-slate-500">
                                Số bát
                              </span>
                              <span className="text-[13px] font-medium text-slate-900">
                                {productInfo.outs || "—"}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    {/* 1/4 Bản vẽ Kỹ thuật Marquette SVG / Hình ảnh SP */}
                    <div className="lg:col-span-1 flex flex-col justify-between lg:pl-4 lg:border-l border-slate-100 min-h-[220px]">
                      <div className="w-full">
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-[10px] uppercase font-semibold text-slate-500">
                            Bản vẽ & Hình ảnh
                          </span>
                          <div className="inline-flex rounded-md border border-slate-200 bg-slate-100/80 p-0.5 text-[11px]">
                            <button
                              type="button"
                              onClick={() => setMediaTab("marquette")}
                              className={`px-2 py-0.5 rounded font-medium transition-all cursor-pointer ${
                                mediaTab === "marquette"
                                  ? "bg-white text-indigo-700 shadow-xs"
                                  : "text-slate-600 hover:text-slate-900"
                              }`}
                            >
                              📐 Marquette
                            </button>
                            <button
                              type="button"
                              onClick={() => setMediaTab("image")}
                              className={`px-2 py-0.5 rounded font-medium transition-all cursor-pointer ${
                                mediaTab === "image"
                                  ? "bg-white text-indigo-700 shadow-xs"
                                  : "text-slate-600 hover:text-slate-900"
                              }`}
                            >
                              🖼️ Ảnh SP
                            </button>
                          </div>
                        </div>

                        {mediaTab === "marquette" ? (
                          <div className="w-full h-[180px]">
                            <POSVGMarquette
                              sheetWidth={sheetWidth}
                              sheetHeight={sheetHeight}
                              ups={upsCount}
                              layoutCode={layoutCode || "BÌNH CHUẨN"}
                              imageUrl={productInfo?.image}
                              className="h-full"
                            />
                          </div>
                        ) : (
                          <div className="w-full h-[180px] bg-white rounded-lg border border-slate-200 overflow-hidden relative flex items-center justify-center p-2 shadow-sm">
                            {productInfo?.image ? (
                              <img
                                src={getUploadUrl(productInfo.image)}
                                alt="Sản phẩm"
                                className="w-full h-full object-contain"
                              />
                            ) : (
                              <div className="text-center text-slate-400">
                                <Package
                                  size={32}
                                  className="mx-auto mb-2 opacity-50"
                                />
                                <p className="text-xs font-medium">Chưa có ảnh</p>
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Thông số kỹ thuật nhanh phản hồi thời gian thực */}
                      <div className="mt-2 pt-2 border-t border-slate-100 flex items-center justify-between text-[11px] text-slate-500">
                        <span>Khổ: <strong className="text-slate-800 font-mono">{sheetWidth}×{sheetHeight}</strong> cm</span>
                        <span>Số con: <strong className="text-indigo-600 font-mono">{upsCount}</strong> UPS</span>
                      </div>
                    </div>
                  </div>

                </CardContent>
              </Card>

              {/* ── Card 3: Kế hoạch + Trạng thái + Ghi chú ── */}
              <Card className="border-none shadow-sm ring-1 ring-slate-200">
                <CardHeader className="bg-slate-50/50 py-3 border-b">
                  <CardTitle className="text-sm font-bold flex items-center gap-2">
                    <Settings className="h-4 w-4 text-slate-500" /> Kế hoạch &
                    Trạng thái
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 space-y-4">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="col-span-1">
                      <form.Field name="deadline">
                        {(field: any) => (
                          <TextField
                            field={field}
                            label="Hạn giao hàng (Deadline)"
                            required
                            type="date"
                          />
                        )}
                      </form.Field>
                    </div>
                    <div className="col-span-1">
                      <form.Field name="priority">
                        {(field: any) => (
                          <ConfigCombobox
                            categoryCode="priority"
                            value={field.state.value ?? ""}
                            onChange={(v) => field.handleChange(v as "LOW" | "NORMAL" | "HIGH" | "URGENT")}
                            label="Mức ưu tiên"
                            valueField="code"
                          />
                        )}
                      </form.Field>
                    </div>
                    <div className="col-span-1">
                      <form.Field name="deploymentModel">
                        {(field: any) => (
                          <ConfigCombobox
                            categoryCode="deployment_model"
                            value={field.state.value ?? ""}
                            onChange={(v) => field.handleChange(v as any)}
                            label="Mô hình triển khai"
                            valueField="code"
                          />
                        )}
                      </form.Field>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-5 gap-3 bg-slate-50 p-4 rounded-lg border border-slate-200 mt-2">
                    <form.Field name="quantity">
                      {(field: any) => (
                        <TanstackFieldWrapper
                          field={field}
                          label="SL Đặt hàng"
                          required
                        >
                          <TanstackFormControl>
                            <NumericInput
                              id={field.name}

                              value={field.state.value ?? ""}
                              placeholder="50000"
                              className="h-9 bg-white"
                              onChange={(e) => {
                                const val = Number(e.target.value);
                                field.handleChange(val);
                                const pct = Number(allowancePct) || 0;
                                const inv = Number(inventory) || 0;
                                const allowance = Math.ceil(val * (pct / 100));
                                (form as any).setFieldValue(
                                  "qtyAllowance",
                                  allowance,
                                );
                                (form as any).setFieldValue(
                                  "qtyPlan",
                                  Math.max(0, val - inv + allowance),
                                );
                              }}
                              onBlur={field.handleBlur}
                            />
                          </TanstackFormControl>
                        </TanstackFieldWrapper>
                      )}
                    </form.Field>

                    <div className="space-y-1.5">
                      <Label className="text-xs font-semibold text-slate-700 whitespace-nowrap">
                        SL lưu kho
                      </Label>
                      <NumericInput
                        placeholder="0"
                        value={inventory}
                        className="h-9 bg-white"
                        onChange={(e) => {
                          setInventory(Number(e.target.value));
                          const qty = (form.state.values as any).quantity || 0;
                          const inv = Number(e.target.value) || 0;
                          const allowance =
                            (form.state.values as any).qtyAllowance || 0;
                          (form as any).setFieldValue(
                            "qtyPlan",
                            Math.max(0, qty - inv + allowance),
                          );
                        }}
                      />
                    </div>

                    <div className="space-y-1.5">
                      <Label className="text-xs font-semibold text-slate-700 whitespace-nowrap">
                        % SL
                      </Label>
                      <NumericInput
                        placeholder="1"
                        value={allowancePct}
                        className="h-9 bg-white"
                        onChange={(e) => {
                          setAllowancePct(Number(e.target.value));
                          const pct = Number(e.target.value) || 0;
                          const qty = (form.state.values as any).quantity || 0;
                          const inv = Number(inventory) || 0;
                          const allowance = Math.ceil(qty * (pct / 100));
                          (form as any).setFieldValue(
                            "qtyAllowance",
                            allowance,
                          );
                          (form as any).setFieldValue(
                            "qtyPlan",
                            Math.max(0, qty - inv + allowance),
                          );
                        }}
                      />
                    </div>

                    <form.Field name="qtyAllowance">
                      {(field: any) => (
                        <TanstackFieldWrapper field={field} label="SL bù hao">
                          <TanstackFormControl>
                            <NumericInput
                              data-testid="po-qty-allowance"
                              value={field.state.value ?? ""}
                              className="h-9 bg-amber-50"
                              onChange={(e) => {
                                const allowance = Number(e.target.value);
                                field.handleChange(allowance);
                                const qty =
                                  (form.state.values as any).quantity || 0;
                                const inv = Number(inventory) || 0;
                                (form as any).setFieldValue(
                                  "qtyPlan",
                                  Math.max(0, qty - inv + allowance),
                                );
                              }}
                            />
                          </TanstackFormControl>
                        </TanstackFieldWrapper>
                      )}
                    </form.Field>

                    <form.Field name="qtyPlan">
                      {(field: any) => (
                        <TanstackFieldWrapper field={field} label="SL Kế hoạch">
                          <TanstackFormControl>
                            <NumericInput
                              value={field.state.value ?? ""}
                              className="h-9 bg-blue-50 font-bold text-blue-800"
                              onChange={(e) =>
                                field.handleChange(Number(e.target.value))
                              }
                            />
                          </TanstackFormControl>
                        </TanstackFieldWrapper>
                      )}
                    </form.Field>
                  </div>
                  <div className="col-span-2 md:col-span-4 mt-4">
                    <form.Field name="notes">
                      {(field: any) => (
                        <TanstackFieldWrapper
                          field={field}
                          label="Lưu ý / Ghi chú đặc biệt"
                        >
                          <TanstackFormControl>
                            <Textarea
                              id={field.name}
                              value={field.state.value ?? ""}
                              placeholder="Lưu ý đặc biệt..."
                              rows={2}
                              onChange={(e) =>
                                field.handleChange(e.target.value)
                              }
                              onBlur={field.handleBlur}
                            />
                          </TanstackFormControl>
                        </TanstackFieldWrapper>
                      )}
                    </form.Field>
                  </div>
                </CardContent>
              </Card>
            
    </>
  );
}
